import '.ir{display:inline-block;}.ssr-plugin'
import '.is{margin-top:1.5rem;}.ssr-plugin'
import '.aw{font-size:0.875rem;}.ssr-plugin'
import '.it{color:var(--palette-blue-500);}.ssr-plugin'
import '.gk{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="ir is aw it gk"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
